/**
 * Enum for URL search parameter names
 * Avoids hardcoding parameter names throughout the codebase
 */
export enum URLParamKey {
  TEST_TYPE = 'testType',
  SESSION_ID = 'sessionId',
  MOVE_TO_CAMERA = 'TestLabCamera',
}

